<div class="form-editor-card" data-testid="form-editor-card" [attr.data-form-type]="config().kind">
  <div class="form-editor-card__left">
    <div class="form-editor-card__icon form-editor-card__icon--prominent">
      <ptl-icon [icon]="icon()" size="m"></ptl-icon>
    </div>
    <div class="form-editor-card__info">
      <span class="form-editor-card__title" data-testid="form-editor-card-title">{{ config().title || (typeKey() | transloco) }}</span>
      <span class="form-editor-card__type">
        {{ typeKey() | transloco }}
        @if (frameworkName(); as name) {
          · <span data-testid="form-evidence-framework">{{ name }}</span>
        }
        @if (config().kind === 'EVIDENCE' && config().tagId) {
          · {{ 'translations.v3Forms.evidence.config.tagged' | transloco }}
        }
      </span>
      <span class="form-editor-card__meta" data-testid="form-evidence-limits">
        @for (limit of limits(); track limit.key; let last = $last) {
          {{ limit.key | transloco: limit.params }}{{ last ? '' : ' · ' }}
        }
        @if (config().allowedMediaTypes.length) {
          ·
          @for (type of config().allowedMediaTypes; track type; let last = $last) {
            {{ 'translations.mediaTypes.' + type | transloco }}{{ last ? '' : ', ' }}
          }
        }
        @if (config().requireDescription) {
          · {{ 'translations.v3Forms.evidence.config.requireDescription' | transloco }}
        }
        @if (config().kind === 'FRAMEWORK_EVIDENCE' && config().allowLearnerDomains) {
          · {{ 'translations.v3Forms.evidence.config.allowLearnerDomains' | transloco }}
        }
        @if (config().required) {
          <span class="form-editor-card__meta form-editor-card__meta--required">
            · {{ 'translations.v3Forms.config.requiredToProgress' | transloco }}
          </span>
        }
      </span>
      @if (domainNames().length) {
        <span class="form-editor-card__meta" data-testid="form-evidence-domains">{{ domainNames().join(' · ') }}</span>
      } @else if (config().kind === 'FRAMEWORK_EVIDENCE' && !config().frameworkUid) {
        <span class="form-editor-card__meta form-editor-card__meta--required" data-testid="form-evidence-unset">{{
          'translations.v3Forms.evidence.framework.notSet' | transloco
        }}</span>
      }
    </div>
  </div>
  @if (!readOnly()) {
    <div class="form-editor-card__actions">
      <ptl-button
        type="link-neutral"
        size="s"
        [icon]="LucideSquarePen"
        [ariaLabel]="'translations.global.button.edit' | transloco"
        data-testid="form-editor-card-configure"
        (clicked)="configure.emit()"
      ></ptl-button>
      <button
        type="button"
        class="form-editor-card__delete"
        data-testid="form-editor-card-remove"
        [attr.aria-label]="'translations.global.button.remove' | transloco"
        (click)="remove.emit()"
      >
        <ptl-icon [icon]="LucideTrash2" size="s"></ptl-icon>
      </button>
    </div>
  }
</div>
